module.exports = __webpack_public_path__ + "img/professionals.74bb9359.png";